import {WindowsDownload} from "../../components/Download/windows";
import {BaseLayout} from "../../layouts/Base";

export const WindowsDownloadPage = () => {
    return (
        <BaseLayout>
            <WindowsDownload/>
        </BaseLayout>
    );
}